<template>
  <el-dialog
    v-if="visibles"
    :visible.sync="visibles"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :destroy-on-close="true"
    top="8vh"
    :show-close="false"
    center
  >
    <dialog-header
      slot="title"
      :title="
        !isEdit
          ? $t('vehicleAlarm.overspeedRule.add')
          : $t('vehicleAlarm.overspeedRule.edit')
      "
      :icon="!isEdit ? 'icon-dialog-add' : 'icon-dialog-update'"
      @close="closeDialog"
    />
    <vue-linetitle>
      <el-form
        ref="form"
        :rules="rulesCenter"
        :model="formInfo"
        label-suffix="："
        label-position="right"
        label-width="auto"
      >
        <el-form-item
          :label="$t('vehicleAlarm.overspeedRule.ruleName')"
          prop="ruleName"
        >
          <el-input
            v-model="formInfo.ruleName"
            clearable
            :placeholder="$t('vehicleAlarm.overspeedRule.ruleName')"
          />
        </el-form-item>
        <el-form-item :label="$t('vehicleAlarm.maxSpeed')" prop="maxSpeed">
          <el-input
            v-model="formInfo.maxSpeed"
            clearable
            :placeholder="$t('vehicleAlarm.maxSpeed')"
          />
        </el-form-item>

        <!-- subuser block↓ -->
        <el-form-item
          v-if="!isEdit && !isDepartment"
          :label="$t(`carMonitor.electric.electricManage.${subUSerName}`)"
          prop="roleId"
        >
          <el-select
            v-model="formInfo.id"
            :placeholder="
              $t(`carMonitor.electric.electricManage.${subUSerName}`)
            "
            filterable
            clearable
          >
            <el-option
              v-for="(item, index) in subUserList"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-row v-if="!isEdit && !isDepartment">
          <el-col>
            <span class="sub-user-tip"
              >{{ $t("vehicleAlarm.overspeedRule.subUserTip")
              }}{{
                $t(`carMonitor.electric.electricManage.${subUSerName}`)
              }}</span
            >
          </el-col>
        </el-row>
        <!-- subuser block↑ -->

        <el-form-item :label="$t('vehicleAlarm.remark')" prop="remark">
          <el-input
            v-model="formInfo.remark"
            :rows="3"
            :autosize="{ minRows: 3, maxRows: 3 }"
            resize="none"
            :placeholder="$t('vehicleAlarm.remark')"
            type="textarea"
            :maxlength="500"
            :show-word-limit="true"
          />
        </el-form-item>
      </el-form>
    </vue-linetitle>
    <span slot="footer" class="dialog-footer">
      <el-button
        v-waves
        class="dialog-cancel"
        type="primary"
        @click="closeDialog"
        >{{ $t("public.cancel") }}</el-button
      >
      <el-button v-waves type="primary" @click="handleSubmit">
        {{ $t("public.define") }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
// 混入
import { partialForm } from '@/mixins/partialForm'
// request
import { overSpeedRuleAddUrl, overSpeedRuleEditUrl } from '@/api/vehicleAlarm/overspeedRule'
import { subUserUrl } from '@/api/electric/geofence'
import resolve from '@/api/resolve'
export default {
  name: 'AddUpdateDialog',
  components: {},
  mixins: [partialForm],
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({}),
      subUserList: []
    }
  },
  computed: {
    isDepartment() {
      return this.$store.getters.roles[0].roleName === "Department"
    },
    subUSerName() {
      return this.$store.getters.roles[0].roleName === "Company"
        ? "subCompany"
        : this.$store.getters.roles[0].roleName === "Sub Company"
          ? "department"
          : ""
    }
  },
  data() {
    const validateRuleName = (rule, value, cb) => {
      if (!this.formInfo.ruleName) return cb(new Error(this.$t('vehicleAlarm.overspeedRule.errorName')))
    }
    const validateMaxSpeed = (rule, value, cb) => {
      if (!this.formInfo.maxSpeed || !(/^(0|[1-9]\d*)(\.\d*[0-9])?$/.test(this.formInfo.maxSpeed))) return cb(new Error(this.$t('vehicleAlarm.overspeedRule.errorSpeed')))
    }
    return {
      formInfo: {},
      rulesCenter: {
        ruleName: [
          { required: true, trigger: ['blur', 'change'], validator: validateRuleName }
        ],
        maxSpeed: [
          { required: true, trigger: ['blur', 'change'], validator: validateMaxSpeed }
        ]
      },
    }
  },
  watch: {
    visibles(v) {
      if (v) {
        this.formInfo = { ...this.data }
      }
    }
  },
  created() {
    if (!this.isDepartment) {
      this._getSubUserList()
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update:visibles', false)
    },
    handleSubmit() {
      const formCheck = this.checkForm({
        formName: 'form',
        formList: ['ruleName', 'maxSpeed']
      })
      if (!formCheck) return

      const { ruleName, maxSpeed, id, remark } = this.formInfo
      const postData = {
        ruleName,
        maxSpeed,
        id,
        remark
      }
      if (!this.isEdit) {
        this._createRule(postData)
      } else {
        this._updateRule(postData)
      }
    },
    _createRule(postData) {
      this.$http.post(overSpeedRuleAddUrl, postData).then(({ data }) => {
        if (data.code === 0) {
          this.$message.success({
            message: this.$t('public.createSuccess'),
            duration: 2 * 1000
          })
          this.$emit('add-complete')
          this.closeDialog()
        }
      })
    },
    _updateRule(postData) {
      this.$http.put(resolve(overSpeedRuleEditUrl, this.formInfo.ruleId), postData).then(({ data }) => {
        if (data.code === 0) {
          this.$message.success({
            message: this.$t('public.updateSuccess'),
            duration: 2 * 1000
          })
          this.$emit('update-complete')
          this.closeDialog()
        }
      })
    },
    _getSubUserList() {
      this.$http.post(subUserUrl).then(({ data }) => {
        if (data.code === 0) {
          this.subUserList = data.data || []
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.sub-user-tip {
  display: inline-block;
  padding: 0 0 15px 100px;
  color: red;
}
</style>
